/**
 * Device Toggle Component
 *
 * Switches between mobile and desktop editing modes in the form builder.
 * Each mode allows different question order and visibility settings.
 */

import { Monitor, Smartphone } from 'lucide-react';
import { cn } from '@/lib/utils';
import { DeviceMode } from './hooks/useFormBuilder';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';

interface DeviceToggleProps {
  deviceMode: DeviceMode;
  onDeviceModeChange: (mode: DeviceMode) => void;
  className?: string;
}

export function DeviceToggle({
  deviceMode,
  onDeviceModeChange,
  className,
}: DeviceToggleProps) {
  return (
    <ButtonGroup className={className}>
      <Button
        variant={deviceMode === 'desktop' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onDeviceModeChange('desktop')}
      >
        <Monitor className="h-4 w-4" />
        <span className="hidden sm:inline">Desktop</span>
      </Button>
      <Button
        variant={deviceMode === 'mobile' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onDeviceModeChange('mobile')}
      >
        <Smartphone className="h-4 w-4" />
        <span className="hidden sm:inline">Mobile</span>
      </Button>
    </ButtonGroup>
  );
}
